import { Paper, Stack, Group, Text, TextInput, NumberInput, Divider } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconClock } from '@tabler/icons-react';
import { ExtensionManifestFormValues } from './types';

interface CommonSettingsFormProps {
  form: UseFormReturnType<ExtensionManifestFormValues>;
}

export function CommonSettingsForm({ form }: CommonSettingsFormProps) {
  return (
    <Paper withBorder p="sm" radius="md">
      <Stack gap="xs">
        <Text fw={500} size="sm">
          元件預設尺寸與互動設定
        </Text>
        <Group grow>
          <TextInput
            label="自訂寬度"
            placeholder="280px"
            {...form.getInputProps('width')}
          />
          <TextInput
            label="自訂高度"
            placeholder="360px"
            {...form.getInputProps('height')}
          />
        </Group>

        <Divider my={4} />

        <NumberInput
          label="無互動休眠秒數 (Sleep Timeout)"
          description="處於待機狀態超過指定秒數無互動時自動進入休眠狀態並切換休眠動作/圖片（預設 60 秒；設為 0 則不休眠）"
          placeholder="60"
          min={0}
          max={3600}
          step={5}
          leftSection={<IconClock size={14} />}
          rightSection={<Text size="xs" c="dimmed">秒</Text>}
          {...form.getInputProps('sleepTimeout')}
        />
      </Stack>
    </Paper>
  );
}
